import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';

import LoanCalculator from './components/LoanCalculator.js';

class App extends Component {
    render() {
        return (
            <div className="App">
                <div className="App-header">
                    <img src={logo} className="App-logo" alt="logo" />
                    <h2>Real Estate Investment Calculator</h2>
                </div>
                <div className="App-body">
                    <LoanCalculator />
                </div>
            </div>
        );
    }
}

export default App;
